module.exports = __webpack_public_path__ + "static/media/5.6-ext-eval.86c25c11.png";